import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideFunctions, getFunctions } from '@angular/fire/functions';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';
import { provideMarkdown } from 'ngx-markdown';
import { TranslateModule } from '@ngstack/translate';
import { LanguageService } from './app/core/services/language.service';

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    provideMarkdown(),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => getFirestore()),
    provideFunctions(() => getFunctions(undefined, 'europe-west2')),
    importProvidersFrom(
      TranslateModule.forRoot({
        supportedLangs: ['en', 'fr'],
        translatePaths: ['assets/i18n']
      })
    ),
    LanguageService
  ]
}).catch(err => console.error(err));

